/*
 * Public API Surface of ngx-qrcode
 */

export * from './lib/qrcode.types';
export * from './lib/qrcode.component';
export * from './lib/qrcode.module';
